import {
  fuelTypeAPItoIFuelType,
  vehicleSizeAPIToISize,
} from './APITransformer';
import type {
  APIFuel,
  APISize,
  DeviceVehicleGraphQL,
  PascalCaseVehicleGraphQLAPI,
} from './Types';

import { getVehicleLabel, type Vehicle } from '@cobliteam/common-types';

import type { DeviceVehicle } from '../device/definitions';

export const pascalCaseVehicleGraphQLAPIToVehicle = (
  vehicle: PascalCaseVehicleGraphQLAPI
): Vehicle => {
  return {
    ...vehicle,
    deviceId: vehicle.device?.id,
    cobliId: vehicle.device?.cobliId,
    deviceType: vehicle.device?.type,
    label: getVehicleLabel(
      vehicle.licensePlate,
      vehicle.model?.name,
      vehicle.model?.brand,
      vehicle.device?.cobliId
    ),
    size: vehicle.size
      ? vehicleSizeAPIToISize(vehicle.size as APISize)
      : undefined,
    fuel: {
      ...vehicle.fuel,
      type: vehicle.fuel?.type
        ? fuelTypeAPItoIFuelType(vehicle.fuel.type as APIFuel)
        : undefined,
    },
  };
};

export const deviceVehicleGraphQLToDeviceVehicle = (
  deviceVehicleGraphQL: DeviceVehicleGraphQL
): DeviceVehicle => ({
  cobliId: deviceVehicleGraphQL.device?.cobliId,
  deviceId: deviceVehicleGraphQL.device?.id,
  id: deviceVehicleGraphQL.id,
  licensePlate: deviceVehicleGraphQL.licensePlate,
  model: deviceVehicleGraphQL.model.name,
  brand: deviceVehicleGraphQL.model.brand,
});
